// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityValues = {
  active: "启用",
  inactive: "停用",
  undefinedStatus: "未定义状态",
  yes: "是",
  no: "否",
  global: "全局",
  loginStatusSuccess: "成功",
  loginStatusFailed: "失败",
  loginAuthFlowPassword: "密码登录",
  loginAuthFlowOidcAuthorize: "OIDC 授权",
  eventActionCreate: "创建",
  eventActionUpdate: "更新",
  eventActionDelete: "删除",
  eventActionSync: "同步",
  eventActionArchive: "归档",
  eventActionInspect: "查看",
  eventActionRotate: "轮换",
  eventActionUpdateStatus: "更新状态",
  eventActionResetPassword: "重置密码",
  eventActionKickout: "踢下线",
  eventActionBatchKickout: "批量踢下线",
  eventActionBatchUpdateStatus: "批量更新状态",
  eventActionMove: "移动",
  eventActionSynced: "已同步",
  eventTypePlatformRoleCreated: "平台角色创建",
  eventTypePlatformRoleUpdated: "平台角色更新",
  eventTypePermissionCreated: "权限点创建",
  eventTypePermissionUpdated: "权限点更新",
  eventTypePermissionBindingUpdated: "权限绑定更新",
  eventTypeUserCreated: "用户创建",
  eventTypeUserUpdated: "用户更新",
  eventTypeUserStatusUpdated: "用户状态更新",
  eventTypeUserPasswordReset: "用户密码重置",
  eventTypeUserKickout: "用户踢下线",
  eventTypeUserBatchKickout: "用户批量踢下线",
  eventTypeUserBatchStatusUpdated: "用户批量状态更新",
  eventTypeUserCustomFieldsUpdated: "用户自定义字段更新",
  eventTypeCustomFieldDefinitionCreated: "自定义字段定义创建",
  eventTypeCustomFieldDefinitionUpdated: "自定义字段定义更新",
  eventTypeCustomFieldDefinitionArchived: "自定义字段定义归档",
  eventTypeTenantCreated: "租户创建",
  eventTypeTenantUpdated: "租户更新",
  eventTypeOrganizationCreated: "组织创建",
  eventTypeOrganizationUpdated: "组织更新",
  eventTypeOrganizationMembershipCreated: "组织成员关系创建",
  eventTypeOrganizationMembershipDeleted: "组织成员关系删除",
  eventTypeOrganizationUnitCreated: "组织单元创建",
  eventTypeOrganizationUnitUpdated: "组织单元更新",
  eventTypeOrganizationUnitDeleted: "组织单元删除",
  eventTypeOrganizationUnitMoved: "组织单元移动",
  eventTypeApplicationCreated: "应用创建",
  eventTypeApplicationUpdated: "应用更新",
  eventTypePlatformRoleAssignmentCreated: "平台角色分配创建",
  eventTypePlatformRoleAssignmentDeleted: "平台角色分配删除",
  eventTypeApplicationGrantCreated: "应用准入规则创建",
  eventTypeApplicationGrantUpdated: "应用准入规则更新",
  eventTypeApplicationGrantDeleted: "应用准入规则删除",
  eventTypePermissionBindingCreated: "权限绑定创建",
  eventTypePermissionBindingDeleted: "权限绑定删除",
  eventTypeApplicationRoleMappingCreated: "应用角色映射创建",
  eventTypeApplicationRoleMappingUpdated: "应用角色映射更新",
  eventTypeApplicationRoleMappingDeleted: "应用角色映射删除",
  eventTypeIdentityApplicationRoleCatalogSynced: "应用角色目录已同步",
  eventTypeApplicationMemberSnapshotSynced: "应用成员摘要已同步",
  eventTypeApplicationCredentialInspected: "应用接入凭据查看",
  eventTypePortalSettingsUpdated: "门户设置更新",
  eventTypeApplicationCredentialRotated: "应用接入凭据轮换",
  eventTypeApplicationCredentialStatusUpdated: "应用接入凭据状态更新",
  eventTypePortalGroupCreated: "门户分组创建",
  eventTypePortalGroupUpdated: "门户分组更新",
  eventTypePortalGroupDeleted: "门户分组删除",
  eventResourceTypePortalSettings: "门户设置",
  eventResourceTypePlatformRole: "平台角色",
  eventResourceTypePermissionDefinition: "权限点定义",
  eventResourceTypePermissionBinding: "权限绑定",
  eventResourceTypeUser: "用户",
  eventResourceTypeUserCustomFields: "用户自定义字段",
  eventResourceTypeIdentityCustomFieldDefinition: "身份自定义字段定义",
  eventResourceTypeTenant: "租户",
  eventResourceTypeOrganization: "组织",
  eventResourceTypeOrganizationMembership: "组织成员关系",
  eventResourceTypeOrganizationUnit: "组织单元",
  eventResourceTypeApplication: "应用",
  eventResourceTypeApplicationGrant: "应用准入规则",
  eventResourceTypeApplicationRoleMapping: "应用角色映射",
  eventResourceTypeApplicationCredential: "应用接入凭据",
  eventResourceTypeApplicationRoleCatalog: "应用角色目录",
  eventResourceTypeApplicationMemberSnapshot: "应用成员摘要",
  eventResourceTypePlatformRoleAssignment: "平台角色分配",
  eventResourceTypePortalGroup: "门户分组",
} as const;
